<script lang="ts">
	//Components
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { AutoChargingMode } from 'src/helpers/xt1_helpers/ev_charger/ev_charger_auto_charging_helpers';
	import type { DeviceButtonV2PropsTypes } from '@Shelly/shelly-design-system/index';

	export let device: Device,
		isWide = false,
		autoChargingMode: AutoChargingMode;
	export let deviceButtonV2Props: Partial<DeviceButtonV2PropsTypes> = {};
</script>

<VirtualBooleanButton
	{isWide}
	{device}
	disabled={autoChargingMode.btnDisabled}
	{deviceButtonV2Props}
	componentID={autoChargingMode.btnID}
	value={autoChargingMode.btnState}
	variant={autoChargingMode.btnVariant}
	icon="fa fa-power-off"
/>
